"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkFieldColumn = void 0;

var _react = _interopRequireDefault(require("react"));

var LinkFieldColumn = function LinkFieldColumn(props) {
  var href = props.href,
      name = props.name;
  return /*#__PURE__*/_react["default"].createElement("a", {
    href: href,
    target: "_blank",
    rel: "noopener noreferrer"
  }, name || href);
};

exports.LinkFieldColumn = LinkFieldColumn;